import request from '@/util/http';

export default {
  login,                  //登录
  loginOut,               //退出登录
  getuserpermission,      //获取所拥有的权限
}

//接口文件呢，post请求参数名为data，get请求参数名为params
function login(data) {
  return request({
    url: 'sys/api/login',
    method: 'post',
    data
  })
}

function loginOut(data) {
  return request({
    url: 'login/exit',
    method: 'get',
    data
  })
}

function getuserpermission(data) {
  return request({
    url: 'sys/api/getuserpermission',
    method: 'post',
    data
  })
}